import {PaletteOptions} from '@material-ui/core/styles/createPalette';
import * as colors from 'assets/theme/colors';

export const palette: PaletteOptions = {
    primary: {
        light: colors.primary.A00,
        main: colors.primary.A20,
        dark: colors.primary.A40,
        contrastText: colors.neutrals.A20,
    },
    secondary: {
        light: colors.secondary.A01,
        main: colors.secondary.A02,
        dark: colors.secondary.A01,
        contrastText: colors.neutrals.A20,
    },
    error: {
        light: colors.feedback.E00,
        main: colors.feedback.E01,
        contrastText: colors.neutrals.A60,
    },
    background: {
        default: colors.neutrals.A10,
    },
    text: {
        disabled: colors.neutrals.A40,
        secondary: colors.secondary.A02,
        primary: colors.secondary.A01,
    },
    warning: {
        light: '#FFFACC',
        main: '#FFE166',
        dark: '#F4A50A',
        contrastText: colors.secondary.A02,
    },
    info: {
        light: '#FFFACC',
        main: '#FFE166',
        dark: '#F4A50A',
        contrastText: colors.secondary.A02,
    },
    success: {
        light: '#E0F6D0',
        main: '#A2DD78',
        dark: '#58B118',
        contrastText: colors.secondary.A02,
    },
};
